// Status belongs to the backend evidence standard. Display never derives a
// READY decision from an accuracy percentage or a separate client threshold.
export const readinessStatusLabel = (status) => ({
  ready: "READY",
  building: "BUILDING",
  developing: "BUILDING",
  limited_evidence: "MORE EVIDENCE",
  insufficient_evidence: "MORE EVIDENCE",
  needs_work: "NEEDS PRACTICE",
  weak: "NEEDS PRACTICE",
  unassessed: "",
  no_evidence: "",
}[status] ?? "BUILDING");

export const readinessFactors = (evidence = {}) =>
  (Array.isArray(evidence.blockingFactors) ? evidence.blockingFactors : [])
    .filter((factor) => typeof factor?.label === "string" && factor.label.trim())
    .slice(0, 3);

export const readinessEvidenceHint = (evidence = {}) => {
  const count = evidence.uniqueQuestions ?? evidence.answeredQuestions;
  const parts = [];
  if (Number.isFinite(Number(count))) parts.push(`${count} unique questions considered`);
  parts.push(...readinessFactors(evidence).map((factor) => factor.label));
  return parts.join(". ");
};
